// extracted by mini-css-extract-plugin
export var addToCartButton = "_qb-b";
export var arrowButtonContainer = "_qb-9";
export var arrowButtonIcon = "_qb-a";
export var carouselArrowButton = "_qb-6";
export var carouselElementContainer = "_qb-1";
export var left = "_qb-7";
export var productDisplayCarouselContainer = "_qb-0";
export var productTileContainer = "_qb-2";
export var productTileImage = "_qb-4";
export var productTileImageContainer = "_qb-3";
export var productTileTitle = "_qb-5";
export var right = "_qb-8";
export var sliderOverflow = "_qb-c";